import React from 'react';
import styled from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';
import Layout from 'components/styled/Layout/Layout';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

import useMedia from 'hooks/useMedia';

import { ReactComponent as OpusLogo } from 'icons/icon-opus-logo.svg';
import { IChartInfoProps } from 'pages/Charts';
import SearchDropdown from 'components/search/SearchDropdown/SearchDropdown';

export const LogoWrapperBase = styled('div')<any>`
  color: white;
  text-align: center;
  margin: ${({ theme, isMobileView }): string =>
    `${isMobileView ? '2em' : theme.spacing.huge} auto`};

  svg {
    width: ${({ logoWidth }): string => logoWidth || '18em'};
    max-width: 80%; /* Smaller on smaller screens so it does not fill up the entire width */
    height: auto;
    object-fit: contain;
  }

  p {
    margin: ${({ theme }): string => theme.spacing.xsmall} 0;
  }

  @media screen and (min-width: 43.75em) {
    margin: ${({ theme }): string => `${theme.spacing.xlarge} auto`};
    padding-top: 3.5em; /** This is the Height of the fixed TopBar */

    p {
      font-size: ${modularScale(1)};
      margin: ${({ theme }): string => theme.spacing.medium} 0;
    }
  }
`;

const LogoWrapper = styled(LogoWrapperBase)`
  margin-bottom: ${({ theme }): string => theme.spacing.small};
  ${({ isMobileScreen }): string | undefined =>
    isMobileScreen && 'margin-top: 15px;'}

  svg {
    height: 1.6875em;
  }

  @media screen and (min-width: 43.75em) {
    padding-top: 10px;
    svg {
      height: 2.68em;
    }

    p {
      margin: ${({ theme }): string => theme.spacing.xxsmall};
      font-size: ${modularScale(-1)};
    }
  }
`;

const HeaderContentWrapper = styled('div')`
  @media screen and (max-width: 40em) {
    ${Layout.MaxWidth} {
      width: 100%;
      max-width: 100%;
      padding: ${({ theme }): string => `0 ${theme.spacing.small}`};
    }
  }
`;

interface IHeaderPanelProps {
  isLargeScreen?: boolean;
  entityTitle?: string;
  entityType?: string;
  chartInfo?: IChartInfoProps;
  topicEntityType?: string;
  isTopicFilterInView?: boolean;
  isExternalUser: boolean;
}

const HeaderPanel: React.FC<IHeaderPanelProps> = (props) => {
  const {
    topicEntityType,
    entityTitle,
    entityType,
    chartInfo,
    isExternalUser,
  } = props;

  const isMobileScreen = useMedia('(max-width: 43.9375em)');

  return (
    <>
      <InViewObserver
        render={({ inview }: any): JSX.Element => (
          <Header entityTitle={entityTitle} isMobileScreen={isMobileScreen}>
            <TopBar entityTitle={entityTitle} isStatic />
            <TopBar
              entityTitle={entityTitle}
              entityType={entityType}
              topicEntityType={topicEntityType}
              inView={inview}
              isSticky
              chartInfo={chartInfo}
              showOnlyOnScroll
            />
            <HeaderContentWrapper>
              <Layout.MaxWidth>
                <LogoWrapper isMobileScreen={isMobileScreen}>
                  <OpusLogo />
                </LogoWrapper>
                <SearchDropdown isExternalUser={isExternalUser} />
              </Layout.MaxWidth>
            </HeaderContentWrapper>
          </Header>
        )}
      />
    </>
  );
};

export default HeaderPanel;
